<form class="form-horizontal">
  <fieldset>

    <!-- Form Name -->
    <legend>Form Name</legend>

    <!-- Text input-->
    <div class="form-group">
      <label class="col-md-4 control-label" for="textinput">Username</label>
      <div class="col-md-4">
        <input id="textinput" name="textinput" type="text" placeholder="" class="form-control input-md" required="" [(ngModel)]="username">

      </div>
    </div>

    <!-- Password input-->
    <div class="form-group">
      <label class="col-md-4 control-label" for="passwordinput">Password</label>
      <div class="col-md-4">
        <input id="passwordinput" name="passwordinput" type="password" placeholder="" class="form-control input-md" required="" [(ngModel)]="password">

      </div>
    </div>

    <!-- Button -->
    <div class="form-group">
      <label class="col-md-4 control-label" for="singlebutton"></label>
      <div class="col-md-4">
        <button id="singlebutton" name="singlebutton" class="btn btn-primary" (click)="submit()">Login</button>
      </div>
    </div>

  </fieldset>
</form>
